import { MaybeRef } from '@vueuse/core'
import { unref } from 'vue-demi'

export interface GetItemPositionOptions {
  fallbackPosition?: MaybeRef<string | undefined>
  fallbackToAvailablePosition?: MaybeRef<boolean | undefined>
}

/**
 * Get item position
 * @param item
 * @param currentActivePositions
 * @param getPositionFromItem
 * @param option
 * @returns
 */
export function getItemPosition<T> (
  item: T,
  currentActivePositions: MaybeRef<string[]>,
  getPositionFromItem: (item: T) => string | undefined,
  option: GetItemPositionOptions = {}
): string | undefined {
  const {
    fallbackPosition,
    fallbackToAvailablePosition
  } = option
  const activePositions = unref(currentActivePositions)
  const position = getPositionFromItem(item)
  if (position != null && activePositions.includes(position)) return position
  const fallback = unref(fallbackPosition)
  if (fallback != null && activePositions.includes(fallback)) return fallback
  return unref(fallbackToAvailablePosition) === true ? activePositions?.[0] : undefined
}
